import { getOperationName } from 'apollo-link'

import {
  GetFeaturedGroupsDocument,
  GetGroupDocument,
  GetGroupsDocument,
  GetNewestsGroupsDocument,
  Group,
  Role,
  useGetGroupCreatorQuery,
  useGetViewerQuery,
  useGroupFeatureMutation,
  useGroupUnFeatureMutation,
} from '@/generated/graphql'

export const useIsGroupAdmin = (group: Group | null | undefined) => {
  const { data: viewerData } = useGetViewerQuery()

  if (!group) {
    return { isGroupAndSysAdmin: false, isGroupAdmin: false }
  }

  const { userId, roles } = viewerData!.viewer

  const isSystemAdmin = !!roles.find((r) => r.role === Role.RootAdmin || r.role === Role.SystemAdmin)
  const isGroupAdmin = !!viewerData!.viewer.roles.find((r) => r.groupId === group.groupId && r.role === Role.GroupAdmin)
  const isGroupCreator = userId === group.creatorUserId

  return {
    isGroupAdmin: isGroupAdmin || isSystemAdmin || isGroupCreator,
    isPrivateGroupAdmin: isGroupAdmin || isGroupCreator,
  }
}

export const useIsGroupCreator = (groupId: number | null | undefined) => {
  if (!groupId) {
    return { isGroupCreator: false }
  }
  const { data: viewerData } = useGetViewerQuery()
  const { data: creatorData } = useGetGroupCreatorQuery({
    variables: {
      groupId,
    },
  })

  const { userId } = viewerData!.viewer
  const creatorUserId = creatorData?.group.creator.userId

  return {
    isGroupCreator: userId === creatorUserId,
  }
}

export const useFeatureGroup = (groupId: number) => {
  const refetchQueries = [
    getOperationName(GetGroupDocument)!,
    getOperationName(GetGroupsDocument)!,
    getOperationName(GetNewestsGroupsDocument)!,
    getOperationName(GetFeaturedGroupsDocument)!,
  ]

  const [featureGroup] = useGroupFeatureMutation({
    variables: {
      groupId,
    },
    refetchQueries,
  })

  const [unFeatureGroup] = useGroupUnFeatureMutation({
    variables: {
      groupId,
    },
    refetchQueries,
  })

  return [featureGroup, unFeatureGroup]
}
